import React from 'react'
import PropTypes from 'prop-types'

const IconEvents = ({ className }) => (
  <svg className={className} viewBox="0 0 13 14">
    <path d="M9.8 7.7H6.3V11.2H9.8V7.7ZM9.1 0V1.4H3.5V0H2.1V1.4H1.4C0.623 1.4 0.00699999 2.03 0.00699999 2.8L0 12.6C0 13.37 0.623 14 1.4 14H11.2C11.97 14 12.6 13.37 12.6 12.6V2.8C12.6 2.03 11.97 1.4 11.2 1.4H10.5V0H9.1ZM11.2 12.6H1.4V4.9H11.2V12.6Z" />
  </svg>
)

IconEvents.propTypes = {
  className: PropTypes.string,
}

export default IconEvents
